import {CommonService} from './../../../shared/utils/common.service';
import {UtilsService} from './../../../shared/utils/utils.service';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {moduloGaritas} from '../diccionarios/balanzaModulo.js';
import {IPlaca} from '../modelos/IPlaca';

@Injectable({
  providedIn: 'root'
})
export class PlacaService {

  private diccionarioModulo: any;
  private url: string;
  private urlMaestros: string;

  constructor(private _util: UtilsService, private _commom: CommonService) {
    this.diccionarioModulo = moduloGaritas;
    this.url = this._util.getUrlBascula();
    this.urlMaestros = this._util.getDatosMaestros();
  }

  obtenerPorId(codMaterial: string): Observable<IPlaca> {
    return this._commom.peticionGetConHeader(
      this.url + this.diccionarioModulo.url.placaTransportista.obtenerPorId + codMaterial
    );
  }

  obtenerPorPlaca(codMaterial: string): Observable<any> {
    return this._commom.peticionGetConHeader(
      this.urlMaestros + this.diccionarioModulo.url.placaTransportista.obtenerPorPlaca + codMaterial
    );
  }

  obtenerPorCedula(codMaterial: string): Observable<IPlaca> {
    return this._commom.peticionGetConHeader(
      this.url + this.diccionarioModulo.url.placaTransportista.obtenerPorCedula + codMaterial
    );
  }
}
